import { useMemo } from 'react';

export interface WebVidaLink {
  id: string;
  title: string;
  description: string;
  url: string;
  icon: string;
  category: 'consultar-manutencao' | 'proposta-adesao';
}

// Dados mockados - links do WebVida
const MOCK_WEBVIDA_LINKS: WebVidaLink[] = [
  // Consultar e Manutenção (4 itens)
  {
    id: '1',
    title: 'Consulta de Apólices',
    description: 'Consulta de apólices',
    url: 'https://www.google.com',
    icon: 'iconDocAnalise',
    category: 'consultar-manutencao',
  },
  {
    id: '2',
    title: 'Manutenção de Dados',
    description: 'Manutenção de dados',
    url: 'https://www.google.com',
    icon: 'iconDadosCorretores',
    category: 'consultar-manutencao',
  },
  {
    id: '3',
    title: 'Consulta de Beneficiários',
    description: 'Consulta de beneficiários',
    url: 'https://www.google.com',
    icon: 'iconFinCartao',
    category: 'consultar-manutencao',
  },
  {
    id: '4',
    title: 'Relatórios e Análises',
    description: 'Relatórios e análises',
    url: 'https://www.google.com',
    icon: 'iconFinGrafico',
    category: 'consultar-manutencao',
  },
  // Proposta de Adesão (4 itens)
  {
    id: '5',
    title: 'Nova Proposta',
    description: 'Nova proposta de adesão',
    url: 'https://www.google.com',
    icon: 'iconDocDocumento',
    category: 'proposta-adesao',
  },
  {
    id: '6',
    title: 'Consulta de Propostas',
    description: 'Consulta de propostas',
    url: 'https://www.google.com',
    icon: 'iconDoc2aVia',
    category: 'proposta-adesao',
  },
  {
    id: '7',
    title: 'Aprovação de Propostas',
    description: 'Aprovação de propostas',
    url: 'https://www.google.com',
    icon: 'iconDocAnalise',
    category: 'proposta-adesao',
  },
  {
    id: '8',
    title: 'Histórico de Propostas',
    description: 'Histórico de propostas',
    url: 'https://www.google.com',
    icon: 'iconFinGrafico',
    category: 'proposta-adesao',
  },
  {
    id: '9',
    title: 'Consulta de Sinistros',
    description: 'Consulta de sinistros',
    url: 'https://www.google.com',
    icon: 'iconDocCalendario',
    category: 'consultar-manutencao',
  },
  {
    id: '10',
    title: 'Solicitação de Reembolso',
    description: 'Solicitação de reembolso',
    url: 'https://www.google.com',
    icon: 'iconFinCartao',
    category: 'consultar-manutencao',
  },
  {
    id: '11',
    title: 'Alteração de Cobertura',
    description: 'Alteração de cobertura',
    url: 'https://www.google.com',
    icon: 'iconDocDocumento',
    category: 'proposta-adesao',
  },
  {
    id: '12',
    title: 'Cancelamento de Apólice',
    description: 'Cancelamento de apólice',
    url: 'https://www.google.com',
    icon: 'iconNavFechar',
    category: 'proposta-adesao',
  },
];

export interface UseWebVidaOptions {
  searchTerm?: string;
}

export interface UseWebVidaReturn {
  links: WebVidaLink[];
  filteredLinks: WebVidaLink[];
}

export const useWebVida = (options?: UseWebVidaOptions): UseWebVidaReturn => {
  const { searchTerm = '' } = options || {};
  const links = MOCK_WEBVIDA_LINKS;

  const filteredLinks = useMemo(() => {
    if (!searchTerm || searchTerm.trim() === '') {
      return links;
    }

    const term = searchTerm.toLowerCase().trim();
    return links.filter(link => {
      const titleMatch = link.title.toLowerCase().includes(term);
      const descriptionMatch = link.description.toLowerCase().includes(term);
      return titleMatch || descriptionMatch;
    });
  }, [searchTerm, links]);

  return {
    links,
    filteredLinks,
  };
};

